var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"v-img",class:[_vm.classstyle],attrs:{"src":_vm.getSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }